import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const IndirectActivityIcon = ({ color = '#3F3F3F'}: Props) => (
  <Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <Path
      d="M10.6667 14.6667H12C12.3536 14.6667 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3334 13.687 13.3334 13.3333V5.33333C13.3339 5.12207 13.2925 4.9128 13.2118 4.7176C13.131 4.52239 13.0123 4.34511 12.8627 4.196L10.4707 1.804C10.3216 1.65435 10.1443 1.53571 9.94909 1.45492C9.75389 1.37414 9.54461 1.33281 9.33335 1.33333H4.00002C3.6464 1.33333 3.30726 1.47381 3.05721 1.72386C2.80716 1.97391 2.66669 2.31304 2.66669 2.66667V4.56667"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M9.33331 1.33333V4.66667C9.33331 4.84348 9.40355 5.01305 9.52858 5.13807C9.6536 5.2631 9.82317 5.33333 9.99998 5.33333H13.3333"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.33331 9.33333V10.8L6.39998 11.4667"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M5.33331 14.6667C7.54245 14.6667 9.33331 12.8758 9.33331 10.6667C9.33331 8.45753 7.54245 6.66667 5.33331 6.66667C3.12417 6.66667 1.33331 8.45753 1.33331 10.6667C1.33331 12.8758 3.12417 14.6667 5.33331 14.6667Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default IndirectActivityIcon;